import { Card, CardContent, Typography, Box } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarHalfRoundedIcon from "@mui/icons-material/StarHalfRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import styles from "./MetricCard.module.scss";

const renderStars = (rating) => {
    const safeRating = Number.isFinite(rating) ? rating : 0;
    const fullStars = Math.floor(safeRating);
    const hasHalfStar = safeRating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
        <div className={styles.starContainer}>
            {Array.from({ length: fullStars }).map((_, i) => (
                <StarRoundedIcon key={`full-${i}`} className={styles.starIcon} />
            ))}
            {hasHalfStar && <StarHalfRoundedIcon className={styles.starIcon} />}
            {Array.from({ length: emptyStars }).map((_, i) => (
                <StarOutlineRoundedIcon key={`empty-${i}`} className={styles.starIcon} />
            ))}
        </div>
    );
};

const MetricCard = ({ title, value, subtitle, trend, trendValue, isRating, isPositive }) => {
    const showTrend =
        typeof trendValue === "number" &&
        !Number.isNaN(trendValue) &&
        trendValue !== 0;

    const isIncrease = showTrend && trendValue > 0;
    const isDecrease = showTrend && trendValue < 0;

    return (
        <Card className={styles.card}>
            <CardContent className={styles.cardContent}>
                <div className={styles.header}>
                    <Typography variant="body2" className={styles.title}>
                        {title}
                    </Typography>

                    {showTrend && (
                        <div
                            className={`${styles.trendPill} ${
                                isPositive ? styles.positive : styles.negative
                            }`}
                        >
                            {isIncrease ? (
                                <TrendingUpIcon className={styles.trendIcon} />
                            ) : isDecrease ? (
                                <TrendingDownIcon className={styles.trendIcon} />
                            ) : (
                                <TrendingUpIcon
                                    className={`${styles.trendIcon} ${styles.neutralIcon}`}
                                />
                            )}
                            {trend}
                        </div>
                    )}
                </div>

                <div className={styles.metricValueContainer}>
                    {isRating && renderStars(parseFloat(value))}
                    <Typography variant="h6" className={styles.metricValue}>
                        {value}
                    </Typography>
                </div>

                {subtitle && (
                    <Typography variant="caption" className={styles.subtitle}>
                        {subtitle}
                    </Typography>
                )}
            </CardContent>
        </Card>
    );
};

export default MetricCard;
